import { EventEmitter } from "events";
import { HostAppEvent } from "./HostAppEventReceiver";

export class HostAppEventHandler extends EventEmitter {

    constructor() {
        super();
    }

    public HandleEvent(event: HostAppEvent, eventInfo: any) {
        switch (event) {
            case HostAppEvent.AUDIO_PLAYER_SEEK_TO:
                this.emit(HostAppEvent[HostAppEvent.AUDIO_PLAYER_SEEK_TO], eventInfo.timestamp);
                break;
            case HostAppEvent.AUDIO_PLAYER_STOP:
                this.emit(HostAppEvent[HostAppEvent.AUDIO_PLAYER_STOP]);
                break;
        }
    }
}